module.exports = __webpack_public_path__ + "assets/img/pdc-documents-compte-payable-ged.803928f0.jpg";